import { render, staticRenderFns } from "./copyOffNode.vue?vue&type=template&id=3aeb7849&"
import script from "./copyOffNode.vue?vue&type=script&lang=js&"
export * from "./copyOffNode.vue?vue&type=script&lang=js&"
import style0 from "./copyOffNode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports